import { render } from "./EmpleadoList.vue?vue&type=template&id=08d056e0&scoped=true"
import script from "./EmpleadoList.vue?vue&type=script&lang=js"
export * from "./EmpleadoList.vue?vue&type=script&lang=js"

import "./EmpleadoList.vue?vue&type=style&index=0&id=08d056e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d056e0"]])

export default __exports__